import React from "react";
import "./component.css";

const Work = () => {
  return (
    <>
      <div className="work contain fadeUp">
        <h1 style={{ fontFamily: "Baloo Bhaijaan 2,cursive" }}>
  Work Experience
</h1>

<div className="workexp">
  <div className="clogo">
    <img
      className="workimg imgs fadeUp"
      src={require("./img/rzp.png")}
      alt="Razorpay"
    />
  </div>

  <div>
    <h4 className="highlight">Razorpay - Product Analyst</h4>
    <h4 className="highlight">Aug 2025 – Present</h4>

    <p>
  Worked closely with <span className="highlight">200+ enterprise merchant accounts</span>,
  engineering teams, and banking partners to investigate complex domestic payment
  issues while identifying <span className="highlight">product gaps and improvement
  opportunities</span>. Analyzed transaction data, SQL queries, API logs, and payment
  workflows to diagnose failures, uncover recurring patterns, and translate customer
  feedback into <span className="highlight">actionable product insights and
  requirements</span>. Collaborated across product, engineering, sales, and business
  teams to support issue resolution, improve payment visibility, and drive
  <span className="highlight">data-driven product decisions</span>.
</p>

  </div>
</div>

<div className="workexp">
  <div className="clogo">
    <img
      className="workimg imgs fadeUp"
      src={require("./img/sjain.jpg")}
      alt="Sjain Ventures"
    />
  </div>

  <div>
    <h4 className="highlight">Sjain Ventures - Software Development Engineer Intern</h4>
    <h4 className="highlight">Sep 2024 – Apr 2025</h4>

    <p>
      Built and optimized <span className="highlight">MERN stack</span> web
      applications with a focus on performance, security, and user experience.
      Developed responsive interfaces, integrated
      <span className="highlight"> REST APIs</span>, implemented authentication
      and payment workflows, and collaborated with cross-functional teams to
      deliver scalable solutions that improved application performance by nearly
      <span className="highlight"> 20%</span>.
    </p>
  </div>
</div>
        
      </div>
    </>
  );
};

export default Work;
